<template>
  <el-tooltip
    effect="dark"
    placement="top"
    :content="tooltip"
    :disabled="!tooltip"
  >
    <div class="rate-cell" :class="[`rate-cell--${color}`]">
      <span class="rate-cell__value">{{ displayValue }}</span>
      <div class="rate-cell__track">
        <div
          class="rate-cell__bar"
          :class="[`progress-${color}`]"
          :style="{ width: barWidth + '%' }"
        ></div>
      </div>
    </div>
  </el-tooltip>
</template>

<script>
import { Tooltip } from 'element-ui'
import { formatRate } from './productPerformance'

export default {
  name: 'RateCell',
  components: {
    [Tooltip.name]: Tooltip
  },
  props: {
    rate: {
      type: Number,
      default: null
    },
    color: {
      type: String,
      default: 'neutral'
    },
    status: {
      type: String,
      default: 'no-data'
    },
    tooltip: {
      type: String,
      default: ''
    },
    barWidth: {
      type: Number,
      default: 0
    }
  },
  computed: {
    displayValue() {
      if (this.status === 'invalid') {
        return '—'
      }
      return formatRate(this.rate)
    }
  }
}
</script>

<style scoped>
.rate-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 90px;
  gap: 4px;
}

.rate-cell__value {
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.2;
  white-space: nowrap;
}

.rate-cell__track {
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background: rgba(139, 149, 167, 0.25);
  overflow: hidden;
}

.rate-cell__bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.25s ease;
}

.rate-cell--red .rate-cell__value,
.progress-red {
  color: #ff4d4f;
}
.progress-red {
  background: #ff4d4f;
}

.rate-cell--orange .rate-cell__value,
.progress-orange {
  color: #ff9f1a;
}
.progress-orange {
  background: #ff9f1a;
}

.rate-cell--green .rate-cell__value,
.progress-green {
  color: #57d17c;
}
.progress-green {
  background: #57d17c;
}

.rate-cell--blue .rate-cell__value,
.progress-blue {
  color: #4da3ff;
}
.progress-blue {
  background: #4da3ff;
}

.rate-cell--neutral .rate-cell__value,
.progress-neutral {
  color: #8b95a7;
}
.progress-neutral {
  background: #8b95a7;
}
</style>
